/**
 * Money as integer cents, so differences and limits never go through floating
 * point. Every amount has two decimals, as the backend stores it.
 */

/** "990.00" -> 99000. A server decimal string. */
export function toCents(amount: string): number {
  const [whole, fraction = ''] = amount.split('.')
  return Number(whole) * 100 + Number(fraction.padEnd(2, '0').slice(0, 2))
}

/** 99000 -> "990.00", the decimal string the backend reads. */
export function fromCents(cents: number): string {
  return `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, '0')}`
}

const GERMAN_AMOUNT = /^(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d{1,2}))?$/
const DOT_DECIMAL = /^(\d+)\.(\d{1,2})$/

/**
 * What staff type, as cents: "1.234,5" -> 123450, "49,50" -> 4950, "49" -> 4900.
 * A dot before three digits separates thousands; a dot before one or two
 * digits is read as a decimal point ("49.50"). `null` when it is no amount.
 */
export function parseAmountInput(input: string): number | null {
  const text = input.replace(/[\s€]/g, '')
  const match = GERMAN_AMOUNT.exec(text) ?? DOT_DECIMAL.exec(text)
  if (!match) return null

  return Number(match[1].replace(/\./g, '')) * 100 + Number((match[2] ?? '').padEnd(2, '0'))
}
